import {
    configureStore,
    UnknownAction,
} from '@reduxjs/toolkit'

import { talkJsSlice } from '../../../store/talkJsSlice'
import { userSlice } from '../../../store/userSlice'
import { mainReducer } from '../../main/redux/rtk/mainSlice'
import { airportSlice } from './store/airportSlice'

type storeInitState = {
    user: any;
    airport: any;
}

export type RootState = ReturnType<typeof mainReducer> & {
    user: ReturnType<typeof userSlice.reducer>
    airport: ReturnType<typeof airportSlice.reducer>
    talkJs: ReturnType<typeof talkJsSlice.reducer>
}

const rootReducer = (state: RootState | undefined, action: UnknownAction) => ({
    ...mainReducer(state, action),
    user: userSlice.reducer(state?.user, action),
    airport: airportSlice.reducer(state?.airport, action),
    talkJs: talkJsSlice.reducer(state?.talkJs, action),
})

export const getStore = (initState: storeInitState) => configureStore({
    reducer: rootReducer,
    preloadedState: { ...rootReducer(undefined, { type: '@@init' }), ...initState },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppStore = ReturnType<typeof getStore>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']

export type ThunkApiConfig = {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string;
    extra: any;
}

// export const createAppAsyncThunk = createAsyncThunk.withTypes<ThunkApiConfig>()
